import { Link, useParams } from 'react-router-dom'

import { useGetCurrentQuestionQuery } from './userQuestionApiSlice'

import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import AnswerForm from './AnswerForm'
import QuestionsArr from './partial/QuestionsArr'
import { useEffect, useState } from 'react'
import CountdownTimer from '../../partial/CountdownTimer'
const Answer = () => {
    useTitle('geshtop-Exercise: Edit QuestionSet')

    const { userQuestionId, groupId, type } = useParams()
    const [userSelectedQuestion, setUserSelectedQuestion] = useState("")

    
    const {
        data: retObj,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetCurrentQuestionQuery({userQuestionId, userSelectedQuestion}, {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })
    if (isError) {
        return <p className="errmsg">{error?.data?.message}</p>
    }

    if (isLoading || !retObj) return <PulseLoader color={"#FFF"} />

    const {currQuestion, complete, userQuestion, qustionsArr, expired, toDate} =retObj

    if(complete || expired )
        return (<>
        <div className='question-header'> <h1>{userQuestion.title}</h1> 
    <QuestionsArr setUserSelectedQuestion={setUserSelectedQuestion} qustionsArr={qustionsArr} expired={expired} />
    </div>
  {expired? <h2> לא ניתן לענות על שאלון זה </h2> : <h2>סיימת לענות על השאלון</h2>}   
         <Link to={`/${type}/${groupId}/user-questions`}>בחזרה לשאלונים</Link>  </> )
    if(!currQuestion){
        return <h1>Loading</h1>
    }
    const content =
    <>

    <div className='question-header'> <h1>{userQuestion.title}</h1> 
    <CountdownTimer targetDate={toDate} />

    <QuestionsArr setUserSelectedQuestion={setUserSelectedQuestion} qustionsArr={qustionsArr} expired={expired} />
    </div>
    <Link to={`/${type}/${groupId}/user-questions`}>בחזרה לשאלונים</Link> 
    <AnswerForm currQuestion={currQuestion} setUserSelectedQuestion={setUserSelectedQuestion} userQuestionId={userQuestionId} answered={currQuestion.answered}  />  
       
    </>

    return content
}
export default Answer